<template>
<div>
<v-toolbar dense class="secondary" >
    <v-toolbar-title style="color:white!important">My Service Wise Earning</v-toolbar-title>
    <v-spacer></v-spacer>
       <v-btn @click="fetchstatement" icon><v-icon color="white">refresh</v-icon></v-btn>
  </v-toolbar>

  <v-data-table
      :headers="headers"
      :items="statementlist"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td >{{ props.item.service }}</td>
        <td >{{ props.item.commission }}</td>
        <td >{{ props.item.surcharge }}</td>
      </template>      
    </v-data-table>
      <v-dialog v-model="dialog" persistent width="300"><v-card color="primary" dark><v-card-text>Please wait <v-progress-linear indeterminate  color="white" class="mb-0"/></v-card-text></v-card></v-dialog>
</div>
</template>

<script>
export default {
   data(){
      return{
         modal:false,
         date1:'',
         menu1:false,
         date2:'',
         menu2:false,
         mobile:'',
         headers: [
               { text: 'Service', value: 'orderno'},
               { text: 'Commission', value: 'time' },
               { text: 'Surcharge', value: 'name' },
         ],
         dialog:false,
         viewstatus:false,
         statementlist:[],
         modal:false,
         search:'',
         summary:{}
      }
   },
   computed:{
      user(){
         return this.$store.getters.user;
      }
   },
   methods:{
     notification(type,message){
        this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000, 
                type:type               
        })
      },
      pushstatement(value){
            let vm = this;
            vm.statementlist = []               
            for(let i =0;i<value.length;i++){
               let doc = value[i]
               vm.statementlist.push({
                  service :doc.Service,
                  commission:doc.Commission,
                  surcharge:doc.Surcharge
               })
               
            }
      
      },
      fetchstatement(){ 
         let vm = this;
         if(!vm.user.phone) return vm.notification("warn","Authentication Required!");
         let doc = {
           'MobileNo':vm.user.phone,
           'Password':vm.user.password,
           'AuthKey':vm.user.authkey,
           'Source':'json',
           'User':vm.user.UserName,           
         }
            vm.dialog = true;                    
            vm.$store.dispatch("axiospost",{
                  url:"MyCommission_Details",
                  data:doc,
            }).then(function (res) {
                  vm.dialog = false;            
                  vm.pushstatement(res.data)
            }).catch(function (error) {
                  vm.notification("error",error.message);
                  vm.dialog = false;            
            })
   }
   },
   mounted(){
      let vm = this;
      vm.fetchstatement()
   }

}
</script>


<style scoped>
.search{
   width:150px;
   float: right;
   height: 34px;
   background: white;
   outline:none;
   margin-left:20px;
   padding-left:10px;
   font-size:1em;
}
.searchbtn{
   margin-right:15px;
   height: 34px;
   margin-left:20px;
   float: right;
   margin-top:0px;
}

</style>





